import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { BasicInfoFields } from "./form/BasicInfoFields";
import { ContactFields } from "./form/ContactFields";
import { ToggleField } from "./form/ToggleField";
import { Input } from "@/components/ui/input";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";

export type ProviderFormData = {
  name: string;
  country: string;
  city: string;
  street: string;
  postcode: string;
  website?: string;
  phone_number: string;
  description?: string;
  is_active: boolean;
  certified: boolean;
  ink_cost?: number;
  certificate_cost?: number;
};

interface ProviderFormProps {
  initialData?: ProviderFormData;
  onSubmit: (data: ProviderFormData) => void;
  onCancel: () => void;
}

export function ProviderForm({ initialData, onSubmit, onCancel }: ProviderFormProps) {
  const form = useForm<ProviderFormData>({
    defaultValues: initialData || {
      name: "",
      country: "",
      city: "",
      street: "",
      postcode: "",
      website: "",
      phone_number: "",
      description: "",
      is_active: true,
      certified: false,
      ink_cost: 0,
      certificate_cost: 0,
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 py-4">
        <BasicInfoFields form={form} />
        <ContactFields form={form} />
        
        <div className="grid grid-cols-2 gap-4">
          <FormField
            control={form.control}
            name="ink_cost"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Ink Cost</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.01"
                    {...field} 
                    onChange={(e) => field.onChange(parseFloat(e.target.value) || 0)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="certificate_cost"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Certificate Cost</FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    step="0.01"
                    {...field} 
                    onChange={(e) => field.onChange(parseFloat(e.target.value) || 0)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <ToggleField
            form={form}
            name="is_active"
            label="Active Status"
            description="Provider will be available for printing when active"
          />
          <ToggleField
            form={form}
            name="certified"
            label="Certification Status"
            description="Provider is certified for high-quality prints"
          />
        </div>

        <div className="flex justify-end space-x-2">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit">
            {initialData ? "Update Provider" : "Add Provider"}
          </Button>
        </div>
      </form>
    </Form>
  );
}